<template>
  <div>
    <div class="chart-container">
      <div class="Hcp-main-header">
        <div class="main-header-left">
          <span>{{$t('dashboard')}}</span>
        </div>
        <div class="main-header-right">
          <button @click="print"><span>{{$t('print')}}</span></button>
          <button class="set" @click="open"><span>{{$t('set')}}</span></button>
          <p>{{$t('period')}}:<span class="time">{{timeRange2}}</span></p>
        </div>
      </div>
      <hr class="small-hr spe-hr">
      <div>
<!--        <p>{{$t("dboard_glucose_statistics")}}</p>-->
        <table class="statics-table">
          <tr>
            <td colspan="2" class="rb bb">{{$t('dboard_glucose')}}</td>
            <td colspan="2" class="rb bb">{{$t('dboard_cgm')}}</td>
            <td colspan="2" class="rb bb">{{$t('dboard_insulin')}}</td>
            <td colspan="2" class="rb bb">{{$t('dboard_carbs')}}</td>
            <td colspan="2" class="bb">{{$t('dboard_exercise')}}</td>
          </tr>
          <tr class="trh1">
            <td colspan="2" class="rb ">{{$t('dboard_glucose_avg')}}</td>
            <td colspan="2" class="rb ">{{$t('dboard_cgm_avg')}}</td>
            <td colspan="2" class="rb ">{{$t('dboard_insulin_avg')}}</td>
            <td colspan="2" class="rb ">{{$t('dboard_carbs_avg')}}</td>
            <td colspan="2" class="">{{$t('dboard_exercise_avg')}}</td>
          </tr>
          <tr class="trh1">
            <td colspan="2" class="rb bb sp"><span class="bbv">{{bgAvg}}</span> {{glucoseUnit}}</td>
            <td colspan="2" class="rb bb"><span class="bbv">{{sgAvg}}</span> {{glucoseUnit}}</td>
            <td colspan="2" class="rb bb"><span class="bbv">{{insAvg}}</span> {{$t('ins_unit2')}}</td>
            <td colspan="2" class="rb bb"><span class="bbv">{{carbAvg}}</span> g</td>

            <td v-if="exerAvgHour==0" colspan="2" class="bb"><span class="bbv">{{exerAvg}}</span>{{$t('t1112_min')}}</td>
            <td v-else colspan="2" class="bb"><span class="bbv">{{exerAvgHour}}</span>{{$t('Hours')}}  &nbsp;<span class="bbv">{{exerAvg}}</span> {{$t('t1112_min')}}</td>
          </tr>
          <tr >
            <td class="rb bb">{{$t('dboard_sd')}}</td>
            <td class="rb bb">{{$t('dboard_num')}}</td>
            <td class="rb bb">{{$t('dboard_sd')}}</td>
            <td class="rb bb">{{$t('dboard_num')}}</td>
            <td class="rb bb">{{$t('dboard_sd')}}</td>
            <td class="rb bb">{{$t('t1112_days')}}</td>
            <td class="rb bb">{{$t('dboard_sd')}}</td>
            <td class="rb bb">{{$t('dboard_num')}}</td>
            <td class="rb bb">{{$t('dboard_sd')}}</td>
            <td class="bb">{{$t('dboard_num')}}</td>
          </tr>
          <tr>
            <td class="rb">{{bgSD}}</td>
            <td class="rb">{{bgNum}}</td>
            <td class="rb">{{sgSD}}</td>
            <td class="rb">{{sgNum}}</td>
            <td class="rb">{{insSD}}</td>
            <td class="rb">{{insNum}}</td>
            <td class="rb">{{carbSD}}</td>
            <td class="rb">{{carbNum}}</td>
            <td class="rb">{{exerSD}}</td>
            <td class="">{{exerNum}}</td>
          </tr>
        </table>
      </div>
      <div id="est-a1c">
        <div class="left"><span class="est-title">{{$t("est_a1c_t1")}} </span>
          <span v-if="a1c_available"><span>{{est_a1c}} &nbsp;</span><span>{{$t("est_a1c_t2")}}</span>
          </span>
          <span v-else><span>{{$t('t1112_Not_available')}}</span>
          </span>

        </div>
        <div class="right"><span class="x_est-ita">{{$t("est_a1c_t3")}}</span></div>
        <div style="clear: both"></div>
      </div>

      <el-col :span="24">
        <div id="chart1_4" class="graph2" :element-loading-text="loadingText"  v-loading="loading">
        </div>
      </el-col>

      <el-col :span="24">
        <div class="row1" >
          <div class="left-table">
            <p>{{$t('dboard_statistics')}}</p>
            <table class="statics-table">
              <tr>
                <td class="bb rb" width="20%">{{$t('dboard_BG')}}</td>
                <td class="bb rb" width="50%">{{$t('dboard_BG_calibration')}}</td>
                <td class="bb">{{bgPerDay}} / {{calibPerDay}}</td>
              </tr>
              <tr>
                <td class="rb">{{$t('dboard_SG')}}</td>
                <td class="rb">{{$t('dboard_AUC_high')}} {{highLevelText}}</td>
                <td class="">{{aucu}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb">{{$t('dboard_AUC_low')}} {{lowLevelText}}</td>
                <td class="">{{aucl}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb">{{$t('dboard_highest_value')}}</td>
                <td class="">{{sgHighest}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb">{{$t('dboard_lowest_value')}}</td>
                <td class="">{{sgLowest}}</td>
              </tr>
            </table>

            <table class="statics-table">
              <!--<tr>
                <td class="rb" width="20%">{{$t('dboard_pump')}}</td>
                <td class="rb bb" width="50%">{{$t('dboard_avg_daily_dose')}}</td>
                <td class="bb">{{insAvg}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb bb">{{$t('dboard_SD')}}</td>
                <td class="bb">{{insSD}}</td>
              </tr>-->
              <tr>
                <td class="rb" width="20%">{{$t('dboard_pump')}}</td>
                <td class="rb bb">{{$t('dboard_daily_basal')}}</td>
                <td class="bb">{{basalPercent}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb bb">{{$t('dboard_daily_bolus')}}</td>
                <td class="bb">{{bolusPercent}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb bb">{{$t('dboard_avg_bolus_num')}}</td>
                <td class="bb">{{avgBolusNum}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb bb">{{$t('dboard_avg_suspend_time')}}</td>
                <td class="bb">{{avgSuspendTime}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb">{{$t('dboard_avg_reservoir_usage')}}</td>
                <td class="">{{patchAvgLife}} {{$t('t1113_days')}}</td>
              </tr>

            </table>
          </div>
<!--  Overall: Time In Range -->
          <div class="right-chart" >
            <div id="chart1_5" :class="{'hide':chart5NoData}"></div>
            <p class="chart_title" :class="{'hide':chart5NoData}">&nbsp;{{$t('t1103_Overall_Tine_In_Range')}}</p>
            <p :class="{'hide':!chart5NoData}" id="chart1_5_no_data">No data</p>
          </div>
        </div>
      </el-col>

      <el-col :span="24">
        <div class="row2 left-table">
          <table class="statics-table mtop">
            <tr>
              <td class="rb bb" width="65%">{{$t('dboard_manual_bolus')}}</td>
              <td class="bb">{{avgManualBolus}}</td>
            </tr>
            <tr>
              <td class="rb bb" width="65%">{{$t('dboard_normal')}}</td>
              <td class="bb">{{avgManualNormalBolus}}</td>
            </tr>
            <tr>
              <td class="rb bb" width="65%">{{$t('dboard_extend')}}</td>
              <td class="bb">{{avgManualExtendBolus}}</td>
            </tr>
            <tr>
              <td class="rb" width="65%">{{$t('dboard_combo')}}</td>
              <td class="">{{avgManualComboBolus}}</td>
            </tr>
          </table>
          <table class="statics-table mtop">
            <tr>
              <td class="rb bb" width="65%">{{$t('dboard_bolus_calculator')}}</td>
              <td class="bb">{{avgWizzardBolus}}</td>
            </tr>
            <tr>
              <td class="rb bb" width="65%">{{$t('dboard_food_bolus')}}</td>
              <td class="bb">{{avgFoodWizzardBolus}}</td>
            </tr>
            <tr>
              <td class="rb" width="65%">{{$t('dboard_corr_bolus')}}</td>
              <td class="">{{avgCorrWizzardBolus}}</td>
            </tr>
            <!-- 123 -->
            <tr>
              <td class="rb bb" width="65%">{{$t('dboard_override_add')}}</td>
              <td class="bb">{{avgWizzardOverrideAdd}}</td>
            </tr>
            <tr>
              <td class="rb" width="65%">{{$t('dboard_override_sub')}}</td>
              <td class="">{{avgWizzardOverrideSub}}</td>
            </tr>
          </table>
        </div>

        <!-- <div class="row2 mid-table">
          <div>
          </div>
        </div>-->
<!-- Basal & Bolus -->
        <div class="row2 right-chart" >
          <div id="chart1_6" :class="{'hide':chart6NoData}" ></div>
          <p class="chart_title" :class="{'hide': chart6NoData}">{{$t('t1103_Basal_Bolus')}}</p>
          <p :class="{'hide':!chart6NoData}" id="chart1_6_no_data">{{$t('t1108_No_data')}}</p>
        </div>



      </el-col>

      <!-- 自动模式统计 -->
      <el-col :span="24" >
        <div class="row1">
          <div class="left-table">
<!--            <p>{{$t('dboard_&')}}</p>-->
            <table class="statics-table">
              <tr>
                <td class=" rb" width="20%">{{$t('t1221_Auto_Mode')}}</td>
                <td class="bb rb" width="50%">{{$t('t1221_Time_in_Auto_Mode')}}</td>
                <td class="bb">{{timeInAutoMode}}</td>
              </tr>
              <tr>
                <td class=" rb" width="20%"></td>
                <td class="bb rb" width="50%">{{$t('t1221_Average_SG_SD')}}</td>
                <td class="bb">{{autoModeSGAvgSD}} {{glucoseUnit}}</td>
              </tr>
              <tr>
                <td class=" rb" width="20%"></td>
                <td class="bb rb" width="50%">{{$t('t1221_Time_in_Target_Range')}}</td>
                <td class="bb">{{autoModeSGInTargetRange}}</td>
              </tr>
              <tr>
                <td class=" rb" width="20%"></td>
                <td class="bb rb" width="50%">{{$t('t1221_Time_above_Range')}}</td>
                <td class="bb">{{autoModeSGAboveRange}}</td>
              </tr>
              <tr>
                <td class=" rb" width="20%"></td>
                <td class="bb rb" width="50%">{{$t('t1221_Time_below_Range')}}</td>
                <td class="bb">{{autoModeSGBelowRange}}</td>
              </tr>
              <tr>
                <td class=" rb" width="20%"></td>
                <td class="bb rb" width="50%">{{$t('t1221_Auto_Basal_per_day')}}</td>
                <td class="bb">{{autoModeBasalPerDay}}</td>
              </tr>
              <tr>
                <td class="bb rb" width="20%"></td>
                <td class="bb rb" width="50%">{{$t('t1221_Auto_Bolus_per_day')}}</td>
                <td class="bb">{{autoModeBolusPerDay}}</td>
              </tr>
              <tr>
                <td class="rb">{{$t('t1221_Auto_Mode_Exits')}}</td>
                <td class="rb">{{$t('t1221_No_Sensor_readings')}}</td>
                <td class="">{{autoModeExitCauseNoSensorReadings}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb">{{$t('t1221_Max_Delivery')}} </td>
                <td class="">{{autoModeExitCauseMaxDelivery}}</td>
              </tr>
              <tr>
                <td class="rb"></td>
                <td class="rb">{{$t('t1221_Min_Delivery')}}</td>
                <td class="">{{autoModeExitCauseMinDelivery}}</td>
              </tr>

            </table>


          </div>

          <div class="right-chart">
            <div id="chart1_7" :class="{'hide':chart7NoData}"></div>
            <p class="chart_title" :class="{'hide':chart7NoData}">&nbsp;{{$t('t1103_Time_in_target_range')}}</p>

            <p :class="{'hide':!chart7NoData}" id="chart1_7_no_data">{{$t('t1108_No_data')}}</p>
          </div>
        </div>
      </el-col>

      <!--<br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>-->
      <!--<p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p>-->

      <!-- -->
      <div style="display: none;">
        <div  >
          <el-col :span="24">
            <div id="chart1_1" class="graph"></div>
          </el-col>
        </div>

        <div class="bolCount">
          <p>{{$t('# of Boluses')}}</p>
          <table class="countLabel">
            <tr id="count">
              <td v-for="i in 48"></td>
            </tr>
          </table>
        </div>
        <el-col :span="24">
          <div id="chart1_3" class="graph"></div>
        </el-col>
        <el-col :span="24">
          <div id="chart1_2" class="graph"></div>
        </el-col>
      </div>
    </div>
    <!--时间选择对话框-->
    <el-dialog  :visible.sync="typeChooseVisible" :size=dialogSize  id="dialog-form2" :show-close="false" >
      <div slot="title" class="patientList-dialog-title">
        <span>{{$t('setPeriod')}}</span>
        <img src="../../assets/cancel.png" @click="cancel">
      </div>
      <div slot class="dialog-body">
        <div class="duration" >
          <span>{{$t('duration')}}</span>
          <select id="duration"  @change = "procTimeRangeSelect" v-model="timeRangeSelect">
            <option value=1>{{$t('7 days')}}</option>
            <option value=2>{{$t('14 days')}}</option>
            <option value=3>{{$t('30 days')}}</option>
            <option value=4>{{$t('90 days')}}</option>
            <option value=0>{{$t('Customize')}}</option>
          </select>
        </div>
        <div class="time-range" :class="{'zh2':!isEn}">
          <p>{{$t('From')}}</p>
          <div class="date">
            <span v-show="!custo">{{staTime}}</span>
            <el-date-picker v-model="value4" type="date"  :editable=false  :picker-options="pickerOptions" v-show="custo"
                            @change="startDateChange" :clearable=false  :placeholder="staTime"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <p>{{$t('To')}}</p>
          <div class="block">
            <el-date-picker v-model="value3" type="date"  :editable=false  :picker-options="pickerOptions"
                            @change="endDateChange"     :clearable=false  :placeholder="endTime"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
        </div>
        <hr class="patientList-small-hr">
      </div>
      <div slot="footer" class="dialog-footer">
        <button @click="dateApply">{{$t('applyM')}}</button>
        <button  class="cancelButton" @click="cancel">{{$t('Cancel')}}</button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import B64 from '../../auth/base64'
  import {loading} from '../mixins/loading'
  import format from '@/lib/format'
  /*
  2019-8-5 NOTES:
  value4 : 选择时间的起始时间， 是Date对象。是日期控件的模型数据。
  value3 : 选择时间的结束时间。
  st,et : 时间戳， 后端请求时用的参数。
  timeRange2: 显示的时间范围。
  * */
  export default {
    mixins: [loading],
    data() {
      return {
        isA:false,value2:'',value3:'', uid:0, st:0,et:0, basal:[],bolus:[],timeSection:[],
        staTime:'',endTime:'',timeRange2:'',isMg:'',glucoseUnit:'',isEn:'',
        basalMax:5,
        custo:false,value4:'',timeType:'',update_time:'',
        timeRangeSelect:1,timeRangeSelectActive:1,
        ts:[[],[]], sg1:[],sgHalf:[],target_high:'',target_low:'',bolus1:[],bolCount:[], sg:[],
        typeChooseVisible:false,dialogSize:'tiny',sgMax:25,bolusMax:20,
        sgDate:['00:00','00:30','01:00','01:30','02:00','02:30','03:00','03:30','04:00','04:30','05:00','05:30','06:00','06:30','07:00','07:30','08:00','08:30','09:00','09:30','10:00','10:30',
          '11:00','11:30','12:00','12:30','13:00','13:30','14:00','14:30','15:00','15:30','16:00','16:30','17:00','17:30','18:00','18:30','19:00','19:30','20:00','20:30','21:00','21:30','22:00','22:30','23:00','23:30'],
        sgDate1:['00:00','','01:00','','02:00','','03:00','','04:00','','05:00','','06:00','','07:00','','08:00','','09:00','','10:00','',
          '11:00','','12:00','','13:00','','14:00','','15:00','','16:00','','17:00','','18:00','','19:00','','20:00','','21:00','','22:00','','23:00',''],

        XTimeMin:0,
        XTimeMax:0,
        XData:[],

        YDataMin:[],
        YDataMax:[],
        YDataMed:[],
        YData10P:[],
        YDataQ1:[],
        YDataQ3:[],
        YData90P:[],

        bgAvg:'--',
        bgSD:'--',
        bgNum:'--',

        sgAvg:'--',
        sgSD:'--',
        sgNum:'--',

        insAvg:'--', insSD:'--', insNum:'--', patchAvgLife:'--',
        carbAvg:'--', carbSD:'--', carbNum:'--',
        exerAvg:'--', exerSD:'--', exerNum:'--',
        exerAvgHour: 0,

        est_a1c:'--',
        a1c_available:false,

        calibPerDay:'--',
        bgPerDay:'--',

        highLevelText:'--',
        lowLevelText:'--',

        aucu:'--',
        aucl:'--',

        sgHighest:'--',
        sgLowest:'--',

        sgDistPie:{},
        sgDistPieLabels:['--', '--', '--', '--'],

        autoModeSGDistPie:{},
        // autoModeSGDistPieLabels:[  'Time below range', 'Time in target range', 'Time above range',],
        autoModeSGDistPieLabels:[  this.$t('t1103_Time_below_range'), this.$t('t1103_Time_in_target_range'),
          this.$t('t1103_Time_above_range'),],

        insPieData:[],

        basalPercent:'--',
        bolusPercent:'--',
        avgBolusNum:'--',
        avgSuspendTime:'--',

        avgManualBolus:'--',
        avgManualNormalBolus:'--',
        avgManualExtendBolus:'--',
        avgManualComboBolus:'--',

        avgWizzardBolus:'--',
        avgFoodWizzardBolus:'--',
        avgCorrWizzardBolus:'--',
        avgWizzardOverrideAdd:'--',
        avgWizzardOverrideSub:'--',

        timeInAutoMode:'--',
        autoModeSGAvgSD:'--',
        autoModeSGInTargetRange:'--',
        autoModeSGAboveRange:'--',
        autoModeSGBelowRange:'--',
        autoModeBasalPerDay:'--',
        autoModeBolusPerDay:'--',
        autoModeExitCauseNoSensorReadings:0,
        autoModeExitCauseMaxDelivery:0,
        autoModeExitCauseMinDelivery:0,

        chart5NoData:false,
        chart6NoData:false,
        chart7NoData:false,


        pickerOptions:{
          disabledDate(time){
            let t1=time.getTime();
            let d2=new Date();
            let t2=d2.getTime();
            //return (t1>t2 || (d2.getYear()-time.getYear())>2 );
            return (t1>t2 || t1<(t2-730*86400*1000));
          }
        },

        //date:['','','','','',''],
        textStyle: {
          color: '#282828',
          fontWeight: 'normal',
          fontSize: '14',
          fontFamily: 'SFUIText-Regular'
        },
        titlePadding: [0, 0, 8, 33],
        grid:{x: '4%', y: '16%', width: '90%', height: '50%',},legend1Right:'',legend2Right:'',
        sgRange: [['', '4.4', '8.9', '13.3', '17.8', '22.2'], ['', '0.2', '0.4', '0.6', '0.8', '1.0']
          , ['', '1', '2', '3', '4', '5'], ['0', '1', '2', '3', '4', '5'], ['', this.$t('Light'), '', this.$t('Medium'), '', this.$t('heavy')]],
        dateTime: ["00:00", " ", "", "3:00", "", "", "6:00", "", "", "9:00", "", "", "12:00", "", "", "15:00", "",
          "", "18:00", "", "", "21:00", "", "", "24:00",],
        yAxisLabel: {interval: 0, margin: 5, textStyle: {color: '#282828', baseline: 'middle'}, showMinLabel: false},
        axisPointer:{
          type:'line',
          axis:'x',
          lineStyle:{color:'#777',}
        },
        devices:['--', '--', '--']
      }
    },
    methods: {

      drawChart1_6(){
        let data=[
          {value:6.75, name:'Bolus'},
          {value:3.25, name:'Basal'},
          //{value:234, name:'联盟广告'},
          //{value:135, name:'视频广告'},
          //{value:1548, name:'搜索引擎'}
        ]
        data=this.insPieData;
        let ins_unit2=this.$t('ins_unit2')

        let that = this;
        this.chart1_6= echarts.init(document.getElementById('chart1_6'));
        this.registLoading('chart1_6',this.chart1_6)
        this.chart1_6.setOption({
          tooltip: {
            trigger: 'item',
            //formatter: "{a} <br/>{b}: {c} ({d}%)"
            //formatter: "{d}%
            //formatter:function(data){
            //  data.percent.toFixed(1)+'%'
            //}
            formatter: function(params, ticket, callback) {
              // console.log('params:', params)
              //if ('Basal')
              return params.percent.toFixed(1)+'%';
            }
          },
          /*legend: {
            orient: 'vertical',
            x: 'left',
            data:['直接访问','邮件营销','联盟广告','视频广告','搜索引擎']
          },*/
          series: [
            {
              name:'insulin_usage',
              type:'pie',
              radius: ['40%', '60%'],
              center: ['45%', '45%'],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: true,
                  position: 'outside',
                  //formatter:"{b}<br/>{c}U,{d}%",
                  formatter:function(params, ticket, callback) {
                    //console.log('params:', params)
                    return params.name+'\n'+params.value+ins_unit2+', '+params.percent.toFixed(1)+'%';
                  }
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    //fontSize: '14',
                    //fontWeight: 'bold'
                  }
                },

              },
              labelLine: {
                normal: {
                  show: false,
                  length:10,
                  length2:15,
                }
              },
              color:['rgba(38,95,156,1)', 'rgba(123,168,220,1)'],
              data:data
            }
          ]
        })
      },
      drawChart1_5(){
        function genData(count) {
          var nameList = [
            '赵', '钱', '孙', '李', '周', '吴', '郑', '王', '冯', '陈', '褚', '卫', '蒋', '沈', '韩', '杨', '朱', '秦', '尤', '许', '何', '吕', '施', '张', '孔', '曹', '严', '华', '金', '魏', '陶', '姜', '戚', '谢', '邹', '喻', '柏', '水', '窦', '章', '云', '苏', '潘', '葛', '奚', '范', '彭', '郎', '鲁', '韦', '昌', '马', '苗', '凤', '花', '方', '俞', '任', '袁', '柳', '酆', '鲍', '史', '唐', '费', '廉', '岑', '薛', '雷', '贺', '倪', '汤', '滕', '殷', '罗', '毕', '郝', '邬', '安', '常', '乐', '于', '时', '傅', '皮', '卞', '齐', '康', '伍', '余', '元', '卜', '顾', '孟', '平', '黄', '和', '穆', '萧', '尹', '姚', '邵', '湛', '汪', '祁', '毛', '禹', '狄', '米', '贝', '明', '臧', '计', '伏', '成', '戴', '谈', '宋', '茅', '庞', '熊', '纪', '舒', '屈', '项', '祝', '董', '梁', '杜', '阮', '蓝', '闵', '席', '季', '麻', '强', '贾', '路', '娄', '危'
          ];
          var legendData = [];
          var seriesData = [];
          var selected = {};
          for (var i = 0; i < count; i++) {
            let name = Math.random() > 0.65
              ? makeWord(4, 1) + '·' + makeWord(3, 0)
              : makeWord(2, 1);
            legendData.push(name);
            seriesData.push({
              name: name,
              value: Math.round(Math.random() * 100000)
            });
            selected[name] = i < 6;
          }

          return {
            legendData: legendData,
            seriesData: seriesData,
            selected: selected
          };

          function makeWord(max, min) {
            var nameLen = Math.ceil(Math.random() * max + min);
            var name = [];
            for (var i = 0; i < nameLen; i++) {
              name.push(nameList[Math.round(Math.random() * nameList.length - 1)]);
            }
            return name.join('');
          }
        }

        let data = genData(4);
        data={
          'legendData':[ 'high', 'target', 'low', 'hypo'],
          'selected':{'hypo':true, 'low':true, 'target':true, 'high':true},
          'seriesData':[
            {name:'high', value:40},
            {name:'target', value:25},
            {name:'low', value:20},
            {name:'hypo', value:15} ]
        }
        data=this.sgDistPie;
        let sgDistPieLabels=this.sgDistPieLabels;
        console.log('dataNum:', data)
        if (!data.dataNum){
          this.chart5NoData=true;
          //return;
        }
        //console.log('data:', data)

        let that = this;
        this.chart1_5= echarts.init(document.getElementById('chart1_5'));
        this.chart1_5.setOption({
          title : {
            text: '',
            subtext: '',
            x:'center'
          },
          tooltip : {
            trigger: 'item',
            //formatter: "{a} <br/>{b} : {c} ({d}%)"
            //formatter: "{d}%"
            formatter: function(params, ticket, callback) {
              //console.log('params:', params)
              return params.percent.toFixed(1)+'%';
            }
          },
          legend: {
            //type: 'scroll',
            show:false,
            selectedMode:false,
            orient: 'vertical',
            right: 10,
            //top: 20,
            bottom: 40,
            data: data.legendData,
            formatter:function(name){
              if ('high'==name) {
                //return '>11.0 mmol/L';
                return sgDistPieLabels[3];
              } else if ('target'==name) {
                //return '5.2 - 11.0 mmol/L';
                return sgDistPieLabels[2];
              } else if ('low'==name) {
                //return '3.1 - 5.2 mmol/L';
                return sgDistPieLabels[1];
              } else if ('hypo'==name) {
                //return '< 3.1 mmol/L';
                return sgDistPieLabels[0];
              }
              return name;
            }

            //selected: data.selected
          },

          series : [
            {
              name: 'sg_dist',
              label:{
                //color:'#fff',
                normal:{
                  position:'outside',
                  //color:['#ff0', '#ff0'],
                  color:'#000',
                  //boarderColor:'#000',
                  //backgroundColor:'#000',
                  //fontStyle:'italic',
                  //fontSize:18,
                  //formatter:'{d}%',
                  formatter:function(data){
                    var range='';
                    var name=data.name;
                    if ('high'==name) {
                      //return '>11.0 mmol/L';
                      range = sgDistPieLabels[3];
                    } else if ('target'==name) {
                      //return '5.2 - 11.0 mmol/L';
                      range = sgDistPieLabels[2];
                    } else if ('low'==name) {
                      //return '3.1 - 5.2 mmol/L';
                      range = sgDistPieLabels[1];
                    } else if ('hypo'==name) {
                      //return '< 3.1 mmol/L';
                      range = sgDistPieLabels[0];
                    }

                    //console.log('data:', data)
                    return range +': '+ data.percent.toFixed(1)+'%';
                  },
                  //formatter: function(v){
                  //  return "{aa|ssa}";
                  //},
                  //formatter:['{a|sss}'].join('\n'),
                  //formatter:'{aa|sss}',
                  rich:{
                    aa:{
                      color:'#000',
                      fontSize:18
                    }
                  }
                }

                //formatter:function(params){
                //  console.log(params)
                //}
              },
              labelLine:{
                normal:{
                  lineStyle:{
                    color:'#000'
                  }
                }
              },
              type: 'pie',
              radius : '65%',
              center: ['50%', '50%'],
              data: data.seriesData,
              //color:['rgba(255,38,38,1)', 'rgba(254,102,102,1)','rgba(42,222,154,1)', 'rgba(255,255,51,1)'],
              color:['rgba(255,170,0,1)', 'rgba(42,222,154,1)', 'rgba(254,102,102,1)', 'rgba(255,38,38,1)'],
              itemStyle: {
                //
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                },

              }
            }
          ]
        })
      },
      drawChart1_7(){
        let id = 'chart1_7'
        function genData(count) {
          var nameList = [
            '赵', '钱', '孙', '李', '周', '吴', '郑', '王', '冯', '陈', '褚', '卫', '蒋', '沈', '韩', '杨', '朱', '秦', '尤', '许', '何', '吕', '施', '张', '孔', '曹', '严', '华', '金', '魏', '陶', '姜', '戚', '谢', '邹', '喻', '柏', '水', '窦', '章', '云', '苏', '潘', '葛', '奚', '范', '彭', '郎', '鲁', '韦', '昌', '马', '苗', '凤', '花', '方', '俞', '任', '袁', '柳', '酆', '鲍', '史', '唐', '费', '廉', '岑', '薛', '雷', '贺', '倪', '汤', '滕', '殷', '罗', '毕', '郝', '邬', '安', '常', '乐', '于', '时', '傅', '皮', '卞', '齐', '康', '伍', '余', '元', '卜', '顾', '孟', '平', '黄', '和', '穆', '萧', '尹', '姚', '邵', '湛', '汪', '祁', '毛', '禹', '狄', '米', '贝', '明', '臧', '计', '伏', '成', '戴', '谈', '宋', '茅', '庞', '熊', '纪', '舒', '屈', '项', '祝', '董', '梁', '杜', '阮', '蓝', '闵', '席', '季', '麻', '强', '贾', '路', '娄', '危'
          ];
          var legendData = [];
          var seriesData = [];
          var selected = {};
          for (var i = 0; i < count; i++) {
            let name = Math.random() > 0.65
              ? makeWord(4, 1) + '·' + makeWord(3, 0)
              : makeWord(2, 1);
            legendData.push(name);
            seriesData.push({
              name: name,
              value: Math.round(Math.random() * 100000)
            });
            selected[name] = i < 6;
          }

          return {
            legendData: legendData,
            seriesData: seriesData,
            selected: selected
          };

          function makeWord(max, min) {
            var nameLen = Math.ceil(Math.random() * max + min);
            var name = [];
            for (var i = 0; i < nameLen; i++) {
              name.push(nameList[Math.round(Math.random() * nameList.length - 1)]);
            }
            return name.join('');
          }
        }

        let data = genData(4);
        data={
          'legendData':[ 'high', 'target', 'low', 'hypo'],
          'selected':{'hypo':true, 'low':true, 'target':true, 'high':true},
          'seriesData':[
            {name:'high', value:40},
            {name:'target', value:25},
            {name:'low', value:20},
            {name:'hypo', value:15} ]
        }
        data=this.autoModeSGDistPie;
        let autoModeSGDistPieLabels=this.autoModeSGDistPieLabels;
        console.log('dataNum:', data)
        if (!data.dataNum){
          this.chart7NoData=true;
          //return;
        }
        //console.log('data:', data)

        let that = this;
        this.chart1_7= echarts.init(document.getElementById(id));
        this.chart1_7.setOption({
          title : {
            text: '',
            subtext: '',
            x:'center'
          },
          tooltip : {
            trigger: 'item',
            //formatter: "{a} <br/>{b} : {c} ({d}%)"
            //formatter: "{d}%"
            formatter: function(params, ticket, callback) {
              //console.log('params:', params)
              return params.percent.toFixed()+'%';
            }
          },
          legend: {
            //type: 'scroll',
            show:false,
            selectedMode:false,
            orient: 'vertical',
            right: 10,
            //top: 20,
            bottom: 40,
            data: data.legendData,
            formatter:function(name){
              if ('high'==name) {
                //return '>11.0 mmol/L';
                return autoModeSGDistPieLabels[2];
              } else if ('target'==name) {
                //return '5.2 - 11.0 mmol/L';
                return autoModeSGDistPieLabels[1];
              } else if ('low'==name) {
                //return '3.1 - 5.2 mmol/L';
                return autoModeSGDistPieLabels[0];
              }
              return name;
            }

            //selected: data.selected
          },

          series : [
            {
              name: 'sg_dist',
              label:{
                //color:'#fff',
                normal:{
                  position:'outside',
                  //color:['#ff0', '#ff0'],
                  color:'#000',
                  //boarderColor:'#000',
                  //backgroundColor:'#000',
                  //fontStyle:'italic',
                  //fontSize:18,
                  //formatter:'{d}%',
                  formatter:function(data){
                    var range='';
                    var name=data.name;
                    if ('high'==name) {
                      //return '>11.0 mmol/L';
                      range = autoModeSGDistPieLabels[2];
                    } else if ('target'==name) {
                      //return '5.2 - 11.0 mmol/L';
                      range = autoModeSGDistPieLabels[1];
                    } else if ('low'==name) {
                      //return '3.1 - 5.2 mmol/L';
                      range = autoModeSGDistPieLabels[0];
                    }

                    //console.log('data.2:', data.name, range, data.percent)
                    return range +': '+ data.percent.toFixed()+'%';
                  },
                  //formatter: function(v){
                  //  return "{aa|ssa}";
                  //},
                  //formatter:['{a|sss}'].join('\n'),
                  //formatter:'{aa|sss}',
                  rich:{
                    aa:{
                      color:'#000',
                      fontSize:18
                    }
                  }
                }

                //formatter:function(params){
                //  console.log(params)
                //}
              },
              labelLine:{
                normal:{
                  lineStyle:{
                    color:'#000'
                  }
                }
              },
              type: 'pie',
              radius : '65%',
              center: ['45%', '45%'],
              data: data.seriesData,
              //color:['rgba(255,38,38,1)', 'rgba(254,102,102,1)','rgba(42,222,154,1)', 'rgba(255,255,51,1)'],
              color:['rgba(255,170,0,1)', 'rgba(42,222,154,1)', 'rgba(254,102,102,1)', 'rgba(255,38,38,1)'],
              itemStyle: {
                //
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                },

              }
            }
          ]
        })
      },
      drawChart1_4(){
        let id='chart1_4'
        let sel_time=new Date(2019,0,1).getTime();
        //console.log('drawChart1_4:'+this.sgDate);
        //console.log('drawChart1_4:'+sel_time);
        //this.Xtime=[];
        if (false){
          this.XData=['A','B','C','D','E','F','G','H','I','J'];
          this.YData10P=[];
          this.YDataQ1=[];
          this.YDataQ3=[];
          this.YData90P=[];
          let first_time=sel_time+5*60*1000;
          for (let i=0; i<144; i++) {
            this.YDataMin.push([first_time+i*60*10*1000, 2, 2]);
            this.YData10P.push([first_time+i*60*10*1000, 4, 2]);
            this.YDataQ1.push([first_time+i*60*10*1000, 2, 2]);
            this.YDataMed.push([first_time+i*60*10*1000, 2, 2]);
            this.YDataQ3.push([first_time+i*60*10*1000, 2, 2]);
            this.YData90P.push([first_time+i*60*10*1000, 4, 2]);
            this.YDataMax.push([first_time+i*60*10*1000, 2, 2]);

            //this.YData.push(2);
            //this.YData2.push(2);
          }
        }


        /*this.YDataMin[5]=null;
        this.YData10P[5]=null;
        this.YDataQ1[5]=null;
        this.YDataMed[5]=null;
        this.YDataQ3[5]=null;
        this.YData90P[5]=null;
        this.YDataMax[5]=null;*/

        this.XTimeMin=sel_time;
        this.XTimeMax=sel_time+86400*1000;

        let that = this;
        this.chart1_4= echarts.init(document.getElementById(id));
        let t_min_max = this.$t('t1103_Min_Max');
        let t_target_range = this.$t('t1103_Target_Range');
        this.chart1_4.setOption({
          title: {
            text:(this.isMg)? this.$t('Sensor Glucose Profile')+' \nmg/dL':this.$t('Sensor Glucose Profile')+' \nmmol/L',
            textStyle: this.textStyle,
            padding: this.titlePadding,
          },
          tooltip : {
            trigger: 'axis',
            //trigger: 'item',
            axisPointer: {
              //type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            },
            //formatter:'{a0}:{c0}',
            formatter:function(params, ticket, callback) {
              //console.log(params);
              if (params instanceof Array) {
                //console.log('params size:'+params.length)
                let paramSize=params.length;
                let strMinute=params[0].axisValueLabel;
                let strTooptip=strMinute.slice(0, 5);
                let t=new Date(params[0].axisValue);
                let minute=t.getHours()*60+t.getMinutes();
                let startMinute=minute-5;
                let endMinute=minute+5;
                function minuteFormat(minute) {
                  let h=Math.floor(minute/60);
                  let m=Math.floor(minute%60);
                  if (h<10) {
                    h='0'+h;
                  }
                  if (m<10) {
                    m='0'+m;
                  }
                  return h+':'+m;
                }
                strTooptip = minuteFormat(startMinute) + ' ~ ' + minuteFormat(endMinute);
                //let strTooptip=startMinute;
                for (let i=paramSize-1; i>=0; i--) {
                    let series=params[i];
                   strTooptip += '<br/>'+series.seriesName+': '+series.value[2]
                }
                return strTooptip;
              }
              return 'Loading';
            }
          },
          xAxis: [{
            type:'time',
            //type:'category',
            //data:this.sgDate,
            //boundaryGap:false,
            //data:this.XData,
            interval:3600*1000,
            min:this.XTimeMin,
            max:this.XTimeMax,
            splitNumber:24,
            // axisLabel:{
            //   show:true,interval:2,
            //   formatter:function(value, index){
            //     //console.log("xAxis label:"+index+','+value);
            //     let minute=index*30;
            //     function PrefixInteger(num, len) {
            //       return (Array(len).join('0')+num).slice(-len);
            //     }
            //     if (index%3){
            //       return '';
            //     }
            //     let texts=[PrefixInteger(minute/30, 2), PrefixInteger(minute%30, 2)];
            //     return texts.join(':');
            //
            //   }
            // },
            axisLabel:{
              showMaxLabel: true,
              margin: 10, textStyle: {color: '#282828', baseline: 'middle'} ,
              formatter:function (value,index) {
                // console.log('time axis:', value, index)
                // if (0==index)
                //   return '';

                // index = index-1
                // let H = new Date(value).getHours();
                index=(value-that.XTimeMin)/3600000;
                let H=index;
                // console.log('time axis:', value, index)
                if(index<24){
                  if(index%3===0){
                    H = H<10 ? ('0'+H+':00' ): H+':00';
                    return  H;
                  }else{
                    return ' ';
                  }
                }else{
                  // console.log('time axis 24H');
                  return '24:00';
                }
              }
            },
            axisLine: {lineStyle: {color: '#ccc'}},
          }],

          yAxis: [
            {
              type: 'value',
              min:0,
              max:this.sgMax,
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
              boundaryGap: false,
              axisTick: {length: 0},
            },

            {
              type: 'value',
              min:0,
              max:this.sgMax,
              axisLabel:{show:false},
              axisLine: {lineStyle: {color: '#ccc'}},
              boundaryGap: false,
              axisTick: {length: 0},
            }
          ],
          grid: this.grid,

          legend:{
            selectedMode:false,
            itemWidth:40,
            itemHeight:15,
            itemGap:25,
            symbolKeepAspect:false,
            //right:this.legend1Right,
            //top:'middle',
            bottom:30,
            formatter:function(name){
              //console.log(name);
              if ('50%'==name) {
                return '50%';
              } else if ('25%'==name) {
                return '25% - 75%';
              } else if ('10%'==name) {
                return '10% - 90%';
              } else if ('Min'==name) {
                // return 'Min/Max';
                return t_min_max;
              } else if ('Max'==name) {
                //return 'Target Range';
                return t_target_range;
              }

              return name;
            },
            //data:[{ name:'50%',icon_x:'image://static/dashboardLegend/Medium.png'}],
            //data:[{ name:'50%',xicon:'none', textStyle:{

            //  }}],
            data:[{
              name:'50%',icon:'image://static/dashboardLegend/Medium.png'
            }, //'50%', '25%', '10%', 'Min', 'Max'
              {
                name:'25%',icon:'image://static/dashboardLegend/IQR.png'
              },
              {
                name:'10%',icon:'image://static/dashboardLegend/10_90.png'
              },
              {
                name:'Min',icon:'image://static/dashboardLegend/Min_Max.png'
              },
              {
                name:'Max',icon:'image://static/dashboardLegend/TargetRange.png'
              },
            ],
            //textStyle:{color:'rgba(0,0,0,0)'}
          },
          series: [

            /*{
              name:'10%',
              type: 'bar',
              barWidth:'60%',
              stack:'sg',
              data:this.sg1[0],
              itemStyle: {
                normal: {
                  barBorderColor: 'rgba(0,0,0,0)',
                  color: 'rgba(0,0,0,0)'
                },
                emphasis: {
                  barBorderColor: 'rgba(0,0,0,0)',
                  color: 'rgba(0,0,0,0)'
                }
              },
              markLine: {
                data: [{ yAxis:(this.isMg)?this.target_low*18:this.target_low}],
                symbol:['circle','circle'],
                silent:true,
                symbolSize: 1,
                lineStyle: {normal: {
                    color: '#2cd200',
                    type: 'solid',
                  }},
                label:{normal:{show:false}},
              },
              markArea: {
                data: [
                  [{yAxis: (this.isMg)?this.target_low*18:this.target_low}, { yAxis:(this.isMg)?this.target_high*18:this.target_high}]
                ],
                tooltip:{show:false},
                itemStyle: {
                  normal: {
                    color: 'rgba(211,255,213,0.6)',
                  }
                }
              },
            },

            {
              name:'25%',
              type: 'bar',
              stack:'sg',
              data:this.sg1[1],
              itemStyle: {
                normal: {
                  barBorderRadius: [0, 0, 20, 20],
                  color: '#a2ebff',
                },
              },

              markLine: {
                data: [{ yAxis:(this.isMg)?this.target_high*18:this.target_high}],
                symbol:['circle','circle'],
                silent:true,
                symbolSize: 1,
                lineStyle: {normal: {
                    color: '#2cd200',
                    type: 'solid',
                  }},
                label:{normal:{show:false}},
              },
            },
            {
              name:'75%',
              type: 'bar',
              stack:'sg',
              data:this.sg1[2],
              itemStyle: {
                normal: {
                  color: '#00ceef',
                },

              },
            },
            {
              name:'90%',
              type: 'bar',
              stack:'sg',
              data:this.sg1[3],
              itemStyle: {
                normal: {
                  barBorderRadius:[20,20,0,0],
                  color:'#a2ebff',
                },

              },
            },*/

            // min
            {
              name: 'Min',
              type: 'line',
              //data:this.sgHalf,
              data: this.YDataMin,
              stack: 'total',
              lineStyle:{
                normal:{
                  color:'#979797',
                  width:1,
                  type:'dashed'
                }
              },
              symbol:'none',
              markArea: {
                data: [
                  [{yAxis: this.target_low}, { yAxis:this.target_high}]
                ],
                tooltip:{show:false},
                itemStyle: {
                  normal: {
                    color: 'rgba(211,255,213,0.6)',
                  }
                }
              },
            },
            // 10%
            {
              name:'10%',
              type:'line',
              //data:this.sgHalf,
              data:this.YData10P,
              stack:'total',
              /*itemStyle: {normal: {
                  color:'transparent',
                  borderColor:'#0095ff',
                  borderWidth:1,
                }},
              lineStyle:{normal:{
                  color:'#e89b00',
                  width:1,
                }},
              symbol:'diamond',
              symbolSize:4,*/
              symbol:'none',
              lineStyle:{
                normal:{
                  color:'rgba(140, 201, 239, 0.5)',
                  width:1
                }
              }

            },
            // 25%
            {
              name: '25%',
              type: 'line',
              //data:this.sgHalf,
              data: this.YDataQ1,
              stack: 'total',
              areaStyle: {
                normal:{
                  color:'rgba(140, 201, 239, 0.5)',
                }
              },
              lineStyle:{
                normal:{
                  color:'rgba(62, 176, 245, 0.6)',
                  width:1
                }
              },
              symbol:'none',

            },
            // 50%
            {
              name: '50%',
              type: 'line',
              //data:this.sgHalf,
              data: this.YDataMed,
              stack: 'total',
              areaStyle: {
                normal:{color:'rgba(62, 176, 245, 0.6)',}
              },
              lineStyle:{
                normal:{
                  color:'#505050',
                  width:1
                }
              },
              symbol:'none',
            },
            // 75%
            {
              name: '75%',
              type: 'line',
              //data:this.sgHalf,
              data: this.YDataQ3,
              stack: 'total',
              areaStyle: {normal:{color:'rgba(62, 176, 245, 0.6)',}},
              lineStyle:{
                normal:{
                  color:'rgba(62, 176, 245, 0.6)',
                  width:1
                }
              },
              symbol:'none',
            },
            // 90%
            {
              name: '90%',
              type: 'line',
              //data:this.sgHalf,
              data: this.YData90P,
              stack: 'total',
              areaStyle: {normal:{color:'rgba(140, 201, 239, 0.5)',}},
              lineStyle:{
                normal:{
                  color:'rgba(62, 176, 245, 0.6)',
                  width:1
                }
              },
              symbol:'none',
            },
            // max
            {
              name: 'Max',
              type: 'line',
              //data:this.sgHalf,
              data: this.YDataMax,
              stack: 'total',
              lineStyle:{
                normal:{
                  color:'#979797',
                  width:1,
                  type:'dashed'
                }
              },
              symbol:'none',
            },
          ],
        })
      },

      drawChart1_1() {
        return;
        let that = this;
        this.chart1_1= echarts.init(document.getElementById('chart1_1'));
        this.chart1_1.setOption({
          title: {
            text:(this.isMg)? this.$t('Sensor Glucose Profile')+' (mg/dL)':this.$t('Sensor Glucose Profile')+' (mmol/L)',
            textStyle: this.textStyle,
            padding: this.titlePadding,
          },
          xAxis: [{
            type:'category',
            data:this.sgDate,
            axisLabel:{show:false,interval:0,},
            axisLine: {lineStyle: {color: '#ccc'}},
          }],
          yAxis: [
            {
              type: 'value',
              min:0,
              max:this.sgMax,
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
              boundaryGap: false,
              axisTick: {length: 0},
            },
            {
              type: 'value',
              min:0,
              max:this.sgMax,
              axisLabel:{show:false},
              axisLine: {lineStyle: {color: '#ccc'}},
              boundaryGap: false,
              axisTick: {length: 0},
            }
          ],
          tooltip:{
            trigger:'axis',
            confine:true,
            axisPointer:this.axisPointer,
            backgroundColor:'#333',
            formatter:function(params){
              let tip = that.tooltipFormat(params,that);
              return tip;
            },
          },
          grid: this.grid,
          legend:{
            selectedMode:false,
            itemWidth:50,
            itemHeight:110,
            right:this.legend1Right,
            top:'middle',
            data:[{ name:'25%',icon:'image://static/segLegend/legend1.png'}],
            textStyle:{color:'rgba(0,0,0,0)'}
          },
          series: [
            {
              name:'10%',
              type: 'bar',
              barWidth:'60%',
              stack:'sg',
              data:this.sg1[0],
              itemStyle: {
                normal: {
                  barBorderColor: 'rgba(0,0,0,0)',
                  color: 'rgba(0,0,0,0)'
                },
                emphasis: {
                  barBorderColor: 'rgba(0,0,0,0)',
                  color: 'rgba(0,0,0,0)'
                }
              },
              markLine: {
                data: [{ yAxis:(this.isMg)?this.target_low*18:this.target_low}],
                symbol:['circle','circle'],
                silent:true,
                symbolSize: 1,
                lineStyle: {normal: {
                    color: '#2cd200',
                    type: 'solid',
                  }},
                label:{normal:{show:false}},
              },
              markArea: {
                data: [
                  [{yAxis: (this.isMg)?this.target_low*18:this.target_low}, { yAxis:(this.isMg)?this.target_high*18:this.target_high}]
                ],
                tooltip:{show:false},
                itemStyle: {
                  normal: {
                    color: 'rgba(211,255,213,0.6)',
                  }
                }
              },
            },
            {
              name:'25%',
              type: 'bar',
              stack:'sg',
              data:this.sg1[1],
              itemStyle: {
                normal: {
                  barBorderRadius: [0, 0, 20, 20],
                  color: '#a2ebff',
                },
              },
              markLine: {
                data: [{ yAxis:(this.isMg)?this.target_high*18:this.target_high}],
                symbol:['circle','circle'],
                silent:true,
                symbolSize: 1,
                lineStyle: {normal: {
                    color: '#2cd200',
                    type: 'solid',
                  }},
                label:{normal:{show:false}},
              },
            },
            {
              name:'75%',
              type: 'bar',
              stack:'sg',
              data:this.sg1[2],
              itemStyle: {
                normal: {
                  color: '#00ceef',
                },

              },
            },
            {
              name:'90%',
              type: 'bar',
              stack:'sg',
              data:this.sg1[3],
              itemStyle: {
                normal: {
                  barBorderRadius:[20,20,0,0],
                  color:'#a2ebff',
                },

              },
            },
            {
              type:'line',
              data:this.sgHalf,
              itemStyle: {normal: {
                  color:'transparent',
                  borderColor:'#0095ff',
                  borderWidth:1,
                }},
              lineStyle:{normal:{
                  color:'#e89b00',
                  width:1,
                }},
              symbol:'diamond',
              symbolSize:4,
            },
          ],
        });
      },
      drawChart1_3() {
        return;
        let that = this;
        this.chart1_3 = echarts.init(document.getElementById('chart1_3'));
        this.chart1_3.setOption({
          title: [
            {
              // text: 'Bolus Insulin (U)',
              //  textStyle: this.textStyle,
              //  padding: this.titlePadding,
              // text:'# of Bolus'
            },
          ],
          tooltip:{
            trigger:'axis',
            confine:true,
            axisPointer:this.axisPointer,
            backgroundColor:'#333',
            formatter:function(params){
              let tip = that.tooltipFormat2(params[0],that);
              return tip;
            },
          },
          xAxis: [{
            type:'category',
            data:this.sgDate,
            axisLabel:{ show:false,interval:0,},
            axisLine: {lineStyle: {color: '#ccc'}},
          }],
          legend:{
            selectedMode:false,
            itemWidth:50,
            itemHeight:118,
            right:this.legend2Right,
            top:'middle',
            data:[{ name:'bolus',icon:'image://static/segLegend/legend2.png'}],
            textStyle:{color:'rgba(0,0,0,0)'}
          },
          yAxis: [
            {
              type: 'value',
              axisLabel: this.yAxisLabel,
              axisLine:{lineStyle:{color:'#ccc'}},
              min:0,
              max:this.bolusMax,
              boundaryGap: false,
              splitLine: {show: false,},
              axisTick: {length: 0},
              name: this.$t('Bolus Insulin')+' '+this.$t('ins_unit'),
              nameTextStyle:{
                color: '#000',
                fontWeight: 'normal',
                fontSize: '13',
                fontFamily: 'SFUIText-Regular'
              },
              nameLocation:'middle',
              nameGap:25,
            },
            {
              type: 'value',
              axisLabel: {show:false},
              axisLine:{lineStyle:{color:'#ccc'}},
              min:0,
              max:this.bolusMax,
              axisTick: {length: 0},
            },
          ],
          grid:this.grid,
          series: [
            {
              name:'bolus',
              type:'boxplot',
              data:this.bolus1,
              hoverAnimation:false,
              boxWidth:['30%','35%'],
              itemStyle: {normal: {borderColor:'#0095ff',},},
            },
          ]
        });
      },
      drawChart1_2() {
        return;
        let that = this;
        this.chart1_2 = echarts.init(document.getElementById('chart1_2'));
        this.chart1_2.setOption({
          title: [
            {
              text: this.update_time,
              textStyle:this.textStyle,
              padding: [5, 0, 8, 50],
            },
          ],
          tooltip:{
            trigger:'axis',
            axisPointer:{type:'line', lineStyle:{color:'#333',}},
            backgroundColor:'#333',
            formatter:function(params){
              // console.log(params);
              let icon  =" <div style='background: #00ff4c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
              let timeDetail ='',value ='';
              params.map(function (e) {
                //   let date = e.value[0];
                //  let time = format.formatterDate5(date);
                //  timeDetail = time[0]+':'+time[1]+'<br>';
                timeDetail =e.value[2]+'<br>';
                value = e.value[1];
              });
              return  timeDetail+icon+'Basal: '+value+that.$t('basal_unit2');
            },
          },
          xAxis: [{
            type: 'time',
            boundaryGap: false,
            min:new Date(this.ts[0][0]*1000),
            max:new Date(this.ts[0][1]*1000),
            interlval:0,
            axisLabel:{
              showMaxLabel:true,
              margin: 10, textStyle: {color: '#282828', baseline: 'middle'} ,
              formatter:function (value,index) {
                let H = that.getXlabel(value,index, that.ts[0][0]);
                return H;
              }
            },
            axisLine: {lineStyle: {color: '#ccc'}},
            splitNumber: 24,
          }],
          yAxis: [
            {
              type:'value',
              boundaryGap: false,
              min:0,
              max:this.basalMax,
              splitNumber:5,
              axisTick: {length: 0},
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
              name:this.$t('Basal Pattern')+' '+this.$t('basal_unit'),
              nameTextStyle:{
                color: '#000',
                fontWeight: 'normal',
                fontSize: '13',
                fontFamily: 'SFUIText-Regular'
              },
              nameLocation:'middle',
              nameGap:25,
            }
          ],
          grid: this.grid,
          series: [
            {
              type: 'line',
              name:'Basal',
              data:this.basal,
              // step:'middle',
              itemStyle: {normal: {color: '#00ff40'}},
              symbolSize:2,
            },
          ]
        });
      },

      getXlabel(value,index, st){
        // let H = new Date(value).getHours();
        index=(value-st*1000)/3600000;
        let H=index;
        if(index<24){
          H = H<10 ? ('0'+H+':00' ): H+':00';
          return  H;
        }else{
          return '24:00';
        }
      },
      tooltipFormat(params,context){
        //console.log(params);
        let tipArray = [0,0,0,0,0],tip = '',time ='', data = context.sg1;
        let icon1  =" <div style='background: #00ceef;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon2  =" <div style='background: #0095ff;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        //获取时间
        if(params[0]){
          time = context.getTimeRange(params[0].name);
        }
        tip  = tip+time+'<br>';
        params.map(function (e,i) {
          let value = e.value;
          if(value!==undefined){
            let seriesIndex = e.seriesIndex,dataIndex =  e.dataIndex;
            if(seriesIndex===0){
              let realData = (context.isMg)?data[0][dataIndex]:data[0][dataIndex].toFixed(1);
              tipArray[4] =icon1+'10% : '+' '+realData;
            }
            if(seriesIndex===1){
              let realData  = data[0][dataIndex]+data[1][dataIndex];
              realData = (context.isMg)?realData:realData.toFixed(1);
              tipArray[3] =icon2+'25% : '+' '+realData;
            }
            if(seriesIndex===4){
              let realData = (context.isMg)?value:value.toFixed(1);
              tipArray[2] =icon2+'50% : '+' '+realData;
            }
            if(seriesIndex===2){
              let realData  = data[0][dataIndex]+data[1][dataIndex]+data[2][dataIndex];
              realData = (context.isMg)?realData:realData.toFixed(1);
              tipArray[1] =icon2+'75% : '+' '+realData;
            }
            if(seriesIndex===3){
              let realData  = data[0][dataIndex]+data[1][dataIndex]+data[2][dataIndex]+data[3][dataIndex];
              realData = (context.isMg)?realData:realData.toFixed(1);
              tipArray[0] =icon1+'90% : '+' '+realData;
            }
          }
        });
        tipArray.map(function (e,i) {
          if(e){
            tip = tip+e+'<br>';
          }
        });
        return tip;
      },
      tooltipFormat2(params,context){
        let index = params.seriesIndex,name = params.name,tip='',value = params.value ;
        if(index===0&&value[1]){
          let time = context.getTimeRange(name);
          let tip1 = ' - '+'10%'+' : '+value[1]+'<br>';
          let tip2 = ' - '+'25%'+' : '+value[2]+'<br>';
          let tip3 = ' - '+'50%'+' : '+value[3]+'<br>';
          let tip4 = ' - '+'75%'+' : '+value[4]+'<br>';
          let tip5 = ' - '+'90%'+' : '+value[5]+'<br>';
          tip= time+'<br>'+ tip5+tip4+tip3+tip2+tip1;
        }
        return tip;
      },
      getTimeRange(val){
        let time = '',t1  =val.split(':');
        if(t1[1]==='00'){
          time =  t1[0]+':00'+' - '+t1[0]+':30';
        }else{
          let t2  = parseInt(t1[0])+1;
          t2 = (t2<10)?('0'+t2):t2;
          time =  t1[0]+':30'+' - '+t2+':00';
        }
        return time;
      },

      drawCharts() {
        // this.initCount();
        // let timer = setTimeout(this.showCount,500);
        //this.drawChart1_1();
        //this.drawChart1_3();
        //this.drawChart1_2();
        this.drawChart1_4();
        this.drawChart1_5();
        this.drawChart1_6();
        this.drawChart1_7();
      },
      chartsDispose(){
        //this.chart1_1.dispose();
        //this.chart1_2.dispose();
        //this.chart1_3.dispose();
        this.chart1_4.dispose();
        this.chart1_5.dispose();
        this.chart1_6.dispose();
        this.chart1_7.dispose();
      },
      handleResize(){
        let win = window.innerWidth;
        let scale = (win<1500)?0.91:0.62;
        const chartWidth = win * scale * 0.98 * 0.94 + 'px';
        //let chart1_1 = document.getElementById('chart1_1');
        //let chart1_2 = document.getElementById('chart1_2');
        //let chart1_3 = document.getElementById('chart1_3');
        let chart1_4 = document.getElementById('chart1_4');
        let chart1_5 = document.getElementById('chart1_5');
        let chart1_6 = document.getElementById('chart1_6');
        let chart1_7 = document.getElementById('chart1_7');
        if(chart1_4){
          //chart1_1.style.width = chartWidth;
          //chart1_2.style.width = chartWidth;
          //chart1_3.style.width = chartWidth;
          chart1_4.style.width = chartWidth;
          chart1_5.style.width = chartWidth*0.6;
          chart1_6.style.width = chartWidth*0.33;
          chart1_7.style.width = chartWidth*0.6;
        }
      },

      // 2021-12-03, 下面代码好像没用了， 是以前的东西。
      // showCount(){
      //   let count =this.bolCount,length=this.bolCount.length;
      //   let tr = document.getElementById('count');
      //   // console.log(count)
      //   for(let i=0;i<length;i++){
      //     let td = tr.getElementsByTagName('td')[count[i][0]];
      //     td.innerHTML = count[i][1];
      //   }
      // },
      // initCount(){
      //   let tr = document.getElementById('count');
      //   let td = tr.getElementsByTagName('td');
      //   for(let i=0;i<td.length;i++){
      //     td[i].innerHTML = '';
      //   }
      //
      // },

      getData(){
        this.ts = auth.getTs(this.st,this.et);
        //console.log(this.ts);
        let param = {
          sg:{ts:this.ts},
          basal:{ts:this.ts},
          bolus:{ts:this.ts},
          event:{ts:this.ts},
          calib:{ts:this.ts},
          custom:{
            usemode:'sa',
            ts:[this.st,this.et]
          }
        };
        /*let that=this;
        auth.getDataMap(this, this.uid, function(res){
          if (0!=res.error) {
            return;
          }
          var end_time=(res.end.cgms > res.end.pump)?res.end.cgms:res.end.pump;
          //console.log(param)
          //var ts_size=param.ts.length;
          //var time_offset=0;
          var cur_end=param.custom.ts[1];
          console.log(cur_end + ', '+end_time);
          for (var d=0; d<3000;d++) {
            if(cur_end>end_time) {
              cur_end -= 24*3600;
            } else {
              break;
            }
          }
          //console.log(d)
          //if (d)
          //  d -= 1;
          var sg_ts=param.sg.ts;
          var ts_size=sg_ts.length;
          for (var i=0; i<ts_size; i++) {
            sg_ts[i][0] -= 24*3600*d;
            sg_ts[i][1] -= 24*3600*d;
          }
          param.sg.ts=sg_ts;
          param.sg.basal=sg_ts;
          param.sg.bolus=sg_ts;
          param.sg.event=sg_ts;
          param.custom.ts[0] -= 24*3600*d;
          param.custom.ts[1] -= 24*3600*d;

          that.st=param.custom.ts[0];
          that.et=param.custom.ts[1];
          that.getDate();
          //console.log(that.timeRange2)
          auth.getSegment(that,that.uid,param);

        })*/
        auth.getDashboard(this,this.uid,param);
        // if(this.dayNum>7){
        // }
      },

      open(){
        this.value4=new Date(this.st*1000);   // 起始时间还原。
        this.staTime=format.formatterDate4(this.st);
        this.value3=new Date(this.et*1000);
        this.endTime=format.formatterDate4(this.et);
        this.timeRangeSelect=this.timeRangeSelectActive;
        if (0==this.timeRangeSelect){
          this.custo=true;
        } else {
          this.custo=false;
        }
        this.typeChooseVisible=true;
        //this.ckeckType();
      },
      /*ckeckType(){
        if(!this.custo){
          if(this.dayNum===7){ this.timeType = this.$t('7 days')}
          else if(this.dayNum===14){ this.timeType = this.$t('14 days')}
          else if(this.dayNum===30){ this.timeType = this.$t('30 days')}
          else if(this.dayNum===90){ this.timeType = this.$t('90 days')}
          else{this.timeType = this.$t('Customize')}
        }else{
          this.timeType = this.$t('Customize');
        }
      },*/
      cancel(){
        this.typeChooseVisible=false;
      },
      dateApply(){
        /*if(!this.value3){   // value3是结束时间。
          let t = this.endTime.split('-');
          this.et = new Date(parseInt(t[2]),parseInt(t[1])-1,parseInt(t[0])).getTime()/1000;
        }else{
          this.et = this.value3.getTime()/1000;
        }
        let duration= document.getElementById('duration').value;
        console.log('duration:', duration);
        if(duration===this.$t('7 days')){this.dayNum = 7;}
        if(duration===this.$t('14 days')){this.dayNum = 14;}
        if(duration===this.$t('30 days')){this.dayNum = 30;}
        if(duration===this.$t('90 days')){this.dayNum = 90;}
        if(duration===this.$t('Customize')){
          if(this.value4){
            let t = this.value4.getTime()/1000;
            this.dayNum = (this.et-t)/86400+1;
            if(this.dayNum<0||this.dayNum>90){
              this.$message.error('Segment Analysis Report Should Be 1-90 Days!');
              this.dayNum = 7;
            }
          }else{
            this.dayNum = 7;
          }
        }
        this.st = this.et - 86400*(this.dayNum-1);*/
        //
        let st=this.value4.getTime()/1000;
        let et=this.value3.getTime()/1000;
        if (st>=et){
          this.$message.error("Date select wrong");
          return;
        }
        this.st=st;
        this.et=et;
        //
        let curDate=new Date();
        if ((curDate.getTime()-this.st*1000)>730*86400*1000){
          //this.$message.error('Can not select date of tow years ago!');
        }
        //
        sessionStorage.setItem('st7',this.st);
        sessionStorage.setItem('et7',this.et);
        sessionStorage.setItem('timeRangeSelect7',this.timeRangeSelect);

        //this.ckeckType();
        this.getDate();
        //this.getData();
        this.typeChooseVisible=false;

        // 保存趋势分析的日期设置
        sessionStorage.setItem('st4', this.st);
        sessionStorage.setItem('et4', this.et);
        sessionStorage.setItem('timeRange4', this.timeRange2);
        sessionStorage.setItem('timeRangeSelect4', this.timeRangeSelect);
        console.log('set st4.2:', this.st);

        // 设置事件报告的时间
        sessionStorage.setItem('st8', this.st);
        sessionStorage.setItem('et8', this.et);
        sessionStorage.setItem('timeRangeSelect8', this.timeRangeSelect);

        //
        // 设置 day by day 的报告
        let daySpan=(this.et-this.st)/86400+1;  // 计算一共有多少天
        let st2=this.et-86400*(7-1);   // 默认
        if (daySpan>7) {
          st2=this.et-86400*(14-1);  // 大于7天， day by day 就改成14天
        }
        sessionStorage.setItem('st2', st2);
        sessionStorage.setItem('et2', this.et);
        // sensor overlay 时间修改
        let st3=this.et-86400*(7-1);   // 默认
        sessionStorage.setItem('st3', st3);
        sessionStorage.setItem('et3', this.et);
        if (!sessionStorage.getItem('week3')) {
          sessionStorage.setItem('week3', 'yyyyyyy');
        }
        // logbook 时间修改
        let st5=this.et-86400*(7-1);   // 默认7天
        if (daySpan>7) {
          st5=this.et-86400*(14-1);  // 大于7天， day by day 就改成14天
        }
        sessionStorage.setItem('st5', st5);
        sessionStorage.setItem('et5', this.et);
        if (!sessionStorage.getItem('week5')) {
          sessionStorage.setItem('week5', 'yyyyyyy');
        }
        // this.$emit('reload')
        window.location.reload()

      },
      getDate(){
        /*this.date = [];
        for(let i=0;i<this.dayNum;i++){
          let day = this.st+i*86400;
          let time = format.formatterDate4(day);
          let weeks =  format.formatterDay(this,day);
          this.date[i] =time+' '+weeks;
        }*/
        this.timeRange2 = format.formatterDate2(this.st)+' - '+format.formatterDate2(this.et);
        this.staTime = format.formatterDate4(this.st);
        this.endTime = format.formatterDate4(this.et);
        this.value4=new Date(this.st*1000);
        this.value3=new Date(this.et*1000);
      },
      //切换时间类型
      /*timeChange(){
        if(!this.value3){
          let t = this.endTime.split('-');
          this.et = new Date(parseInt(t[2]),parseInt(t[1])-1,parseInt(t[0])).getTime()/1000;
        }else{
          this.et = this.value3.getTime()/1000;
        }
        let duration= document.getElementById('duration').value;
        if(duration===this.$t('7 days')){this.dayNum = 7;}
        if(duration===this.$t('14 days')){this.dayNum = 14;}
        if(duration===this.$t('30 days')){this.dayNum = 30;}
        if(duration===this.$t('90 days')){this.dayNum = 90;}
        if(duration===this.$t('Customize')){
          this.custo = true;
          this.st = this.et - 86400*6;
        }else{
          this.custo = false;
          this.st = this.et - 86400*(this.dayNum-1);
        }
        this.staTime = format.formatterDate4(this.st);
      },*/
      startDateChange(){

      },
      endDateChange(){
        let endDate=this.value3;    // 选择的结束时间。
        let et=endDate.getTime()/1000;  // unix 时间戳
        let daySpan=0;
        if (1==this.timeRangeSelect) {
          daySpan=7;
        } else if (2==this.timeRangeSelect){
          daySpan=14;
        } else if (3==this.timeRangeSelet) {
          daySpan=30;
        } else if (4==this.timeRangeSelect) {
          daySpan=90;
        }
        if (daySpan) {
          let st=et-86400*(daySpan-1);  // 计算起始时间
          this.value4=new Date(st*1000);  // 开始时间控件的变量
          this.staTime = format.formatterDate4(st); // 开始时间的显示。
        }
      },
      procTimeRangeSelect(e){
        console.log('procTimeRangeSelect:', this.timeRangeSelect);
        let daySpan=0;
        if (1==this.timeRangeSelect){   // 7天
          daySpan=7;
        } else if (2==this.timeRangeSelect){  // 14天
          daySpan=14;
        } else if (3==this.timeRangeSelect || 4==this.timeRangeSelect){  // 30天
          daySpan=30;
          if (4==this.timeRangeSelect) {
            daySpan=90;
          }
        }
        //
        let et=this.value3.getTime()/1000;   // 控件上的时间。

        console.log('daySpan:', daySpan);
        this.dayNum=daySpan;
        if (daySpan) {
          let st=et-86400*(daySpan-1);
          this.staTime=format.formatterDate4(st);
          this.value4=new Date(st*1000);
        }
        if (0==this.timeRangeSelect) {
          //this.startDateDisable=false;
          this.custo=true;
        } else {
          //this.startDateDisable=true;
          this.custo=false;
        }
        console.log('startDateDisable:', this.startDateDisable);
      },

      print(){
        //let src1 = this.chart1_1.getDataURL();
        //let src2 = this.chart1_2.getDataURL();
        //let src3 = this.chart1_3.getDataURL();
        let src1 = this.chart1_4.getDataURL();
        let src2 = this.chart1_5.getDataURL();
        let src3 = this.chart1_6.getDataURL();
        let src4 = this.chart1_7.getDataURL();
        sessionStorage.setItem('src7_1',src1);
        sessionStorage.setItem('src7_2',src2);
        sessionStorage.setItem('src7_3',src3);
        sessionStorage.setItem('src7_4',src4);
        sessionStorage.setItem('timeRange7',this.timeRange2);
        sessionStorage.setItem('targetH7',this.target_high);
        sessionStorage.setItem('targetL7',this.target_low);
        sessionStorage.setItem('sg7',JSON.stringify(this.sg));
        sessionStorage.setItem('count7',JSON.stringify(this.bolCount));
        sessionStorage.setItem('st7',this.st);
        sessionStorage.setItem('et7',this.et);
        sessionStorage.setItem('dashboardStatInfo', JSON.stringify({
          devices: this.devices,
          bgAvg: this.bgAvg,
          bgSD: this.bgSD,
          bgNum: this.bgNum,

          sgAvg:this.sgAvg,
          sgSD:this.sgSD,
          sgNum:this.sgNum,

          insAvg:this.insAvg, insSD:this.insSD, insNum:this.insNum, patchAvgLife:this.patchAvgLife,
          carbAvg:this.carbAvg, carbSD:this.carbSD, carbNum:this.carbNum,
          exerAvg:this.exerAvg, exerSD:this.exerSD, exerNum:this.exerNum,

          est_a1c:this.est_a1c,
          a1c_available:this.a1c_available,

          calibPerDay:this.calibPerDay,
          bgPerDay:this.bgPerDay,

          highLevelText:this.highLevelText,
          lowLevelText:this.lowLevelText,

          aucu:this.aucu,
          aucl:this.aucl,

          sgHighest:this.sgHighest,
          sgLowest:this.sgLowest,

          //sgDistPie:this.est_a1c,
          //sgDistPieLabels:['--', '--', '--', '--'],

          //insPieData:[],

          basalPercent:this.basalPercent,
          bolusPercent:this.bolusPercent,
          avgBolusNum:this.avgBolusNum,
          avgSuspendTime:this.avgSuspendTime,

          avgManualBolus:this.avgManualBolus,
          avgManualNormalBolus:this.avgManualNormalBolus,
          avgManualExtendBolus:this.avgManualExtendBolus,
          avgManualComboBolus:this.avgManualComboBolus,

          avgWizzardBolus:this.avgWizzardBolus,
          avgFoodWizzardBolus:this.avgFoodWizzardBolus,
          avgCorrWizzardBolus:this.avgCorrWizzardBolus,
          avgWizzardOverrideAdd:this.avgWizzardOverrideAdd,
          avgWizzardOverrideSub:this.avgWizzardOverrideSub,
          chart5NoData:this.chart5NoData,
          chart6NoData:this.chart6NoData,
          chart7NoData:this.chart7NoData,

          timeInAutoMode:this.timeInAutoMode,
          autoModeSGAvgSD:this.autoModeSGAvgSD,
          autoModeSGInTargetRange:this.autoModeSGInTargetRange,
          autoModeSGAboveRange:this.autoModeSGAboveRange,
          autoModeSGBelowRange:this.autoModeSGBelowRange,
          autoModeBasalPerDay:this.autoModeBasalPerDay,
          autoModeBolusPerDay:this.autoModeBolusPerDay,
          autoModeExitCauseNoSensorReadings:this.autoModeExitCauseNoSensorReadings,
          autoModeExitCauseMaxDelivery:this.autoModeExitCauseMaxDelivery,
          autoModeExitCauseMinDelivery:this.autoModeExitCauseMinDelivery,

          })
        )

        window.open('/#/chart0-print','_blank');
      }
    },
    mounted: function () {
      let win = window.innerWidth;
      this.dialogSize =(win<1500)?'small':'tiny';
      this.legend1Right =(win<1150)?-35:-30;
      this.legend2Right =(win<1150)?-43:-38;
      this.isEn = (sessionStorage.getItem('language')!=='zh')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.glucoseUnit=(this.isMg)?'mg/dL':'mmol/L';
      this.titleText = (this.isMg)?this.$t('SG')+' (mg/dL)':this.$t('SG')+' (mmol/L)';
      this.sgMax = (this.isMg)? 400:25;
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }

      console.log('mounted:', sessionStorage.getItem('st7'));
      if(!sessionStorage.getItem('st7')){
        //this.et= new Date().setHours(0,0,0,0)/1000-86400;
        var nd=new Date();
        var cur_day=new Date(nd.getFullYear(), nd.getMonth(), nd.getDate()-1)
        this.et=cur_day/1000;
        var chart_end_time=sessionStorage.getItem('chart_end_time')
        console.log('chart_end_time:', chart_end_time);
        for (var d=0; d<3000; d++) {
          if (this.et > chart_end_time) {
            //this.et -= 24*3600;
            cur_day=new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate()-1)
            this.et=cur_day/1000;
          } else {
            break;
          }
        }
        this.st = this.et-86400*6;
      }else{
        this.st = parseInt(sessionStorage.getItem('st7'));
        this.et = parseInt(sessionStorage.getItem('et7'));
        let timeRangeSelect7 =parseInt(sessionStorage.getItem('timeRangeSelect7'));
        if (timeRangeSelect7!=NaN && timeRangeSelect7>=0 && timeRangeSelect7<=4){
          this.timeRangeSelect=timeRangeSelect7;
        } else {
          this.timeRangeSelect=0;
        }
        this.timeRangeSelectActive=this.timeRangeSelect;
      }
      console.log('timeRangeSelect:', this.timeRangeSelect);
      //console.log('dashboard:', this.st, this.et)
      sessionStorage.setItem('st7',this.st);  // st7就是 dashboard页面用的时间
      sessionStorage.setItem('et7',this.et);
      sessionStorage.setItem('timeRangeSelect7',this.timeRangeSelect);

      this.dayNum = (this.et-this.st)/86400+1;
      this.getDate();
      this.getData();
      // 设置趋势分析的时间
      sessionStorage.setItem('st4', this.st);
      sessionStorage.setItem('et4', this.et);
      sessionStorage.setItem('timeRange4', this.timeRange2);
      sessionStorage.setItem('timeRangeSelect4', this.timeRangeSelect);
      console.log('set st4.1:', this.st);
      // 设置事件报告的时间
      sessionStorage.setItem('st8', this.st);
      sessionStorage.setItem('et8', this.et);
      sessionStorage.setItem('timeRangeSelect8', this.timeRangeSelect);

      //
      // 设置 day by day 报告的时间
      let daySpan=(this.et-this.st)/86400+1;  // 计算一共有多少天
      let st2=this.et-86400*(7-1);   // 默认
      if (daySpan>7) {
        st2=this.et-86400*(14-1);  // 大于7天， day by day 就改成14天
      }
      sessionStorage.setItem('st2', st2);
      sessionStorage.setItem('et2', this.et);
      // sensor overlay 时间修改
      let st3=this.et-86400*(7-1);   // 默认
      sessionStorage.setItem('st3', st3);
      sessionStorage.setItem('et3', this.et);
      if (!sessionStorage.getItem('week3')) {
        sessionStorage.setItem('week3', 'yyyyyyy');
      }
      // logbook 时间修改
      let st5=this.et-86400*(7-1);   // 默认7天
      if (daySpan>7) {
        st5=this.et-86400*(14-1);  // 大于7天， day by day 就改成14天
      }
      sessionStorage.setItem('st5', st5);
      sessionStorage.setItem('et5', this.et);
      if (!sessionStorage.getItem('week5')) {
        sessionStorage.setItem('week5', 'yyyyyyy');
      }

      //
      let that = this;
      window.onresize = function () {
        that.handleResize();
        //if(that.chart1_1){
        if(that.chart1_4){
          //that.chart1_1.resize();
          //that.chart1_2.resize();
          //that.chart1_3.resize();
          that.chart1_4.resize();
          that.chart1_5.resize();
          that.chart1_6.resize();
          that.chart1_7.resize();
        }
      }
    }
  }
</script>

<style scoped>
  .chart-container {
    width: 100%;
    min-height:680px;
    float: left;
    font-family:SFUIText-Regular;
    font-size:14px;
    color:#282828;
    letter-spacing:-0.34px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    margin-top:10px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }

  .main-header-right{
    float: right;
    width:80%;
    height:30px;
    line-height: 30px;
    margin-right: 1%;
  }
  .main-header-right p{
    float: right;
    margin-right:15px;
    margin-top:2px;
  }
  .main-header-right .time{
    font-size:16px;
    letter-spacing:-0.39px;
    color:#0082d2;
    margin-left: 10px;
  }
  .main-header-right button{
    float: right;
    border-radius:100px;
    box-shadow:0 3px 4px 0 #e8f3ff;
    background: #fff;
    border: 1px solid #a3a3a3;
    width:110px;
    height:26px;
    line-height: 26px;
    outline: none;
    margin-top:4px;
    margin-left: 3%;
    cursor: pointer;
  }
  button:hover{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    color:#fff;
  }
  button span{
    font-family:SFUIText-Regular;
    font-size: 16px;
    letter-spacing:-0.39px;
  }
  .main-header-right .set{
    margin-left: 0;
  }
  .el-date-editor.el-input{
    width:125px;
  }

  .small-hr{
    background:#e6e8ea;
    width:97%;
    height:1px;
    margin:10px auto 20px;
    border:none;
  }
  .spe-hr{
    margin-bottom:20px ;
  }
  .chart-container .graph{
    width:100%;
    height:170px;
    margin-bottom: 15px;
  }
  .chart-container .graph2{
    width:100%;
    height:300px;
    margin-bottom: 15px;
  }
  .bolCount{
    width:94%;
    height:30px;
    clear: both;
    margin:0 auto -26px;
  }
  .bolCount p{
    height: 15px;
  }
  .countLabel{
    width: 96%;
    height: 15px;
    margin-left: 1%;
    font-family:SFUIText-Regular;
    font-size:12px;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .countLabel td{
    border:none;
    * border: 1px solid #ccc;
  }


  /*选择日期范围时样式*/
  .time-range p{
    margin: 0 18px 18px;
    margin-top: 2px;
  }
  .time-range button{
    float: right;
    margin-right: 2.2%;
  }
  /*对话框*/
  #dialog-form2{
    font-family:SFUIText-Regular;
  }
  .patientList-dialog-title{
    float: left;
    background-image:linear-gradient(90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .patientList-dialog-title span{
    margin-left: 42px;
  }
  .patientList-dialog-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .dialog-body{
    width:100%;
    margin-top: 25px;
  }
  .patientList-small-hr{
    background:#dedede;
    width:94%;
    height:1px;
    margin:20px 0 10px 10px;
    border:none;
    clear: both;
  }
  .duration{
    margin-left: 20px;
    height:35px;
    line-height: 35px;
    margin-bottom: 20px;
  }
  .duration span{
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    letter-spacing:-0.44px;
    text-align:center;
    margin-left: 18px;
    margin-right: 15px;
  }
  .duration select{
    height: 30px;
    width: 120px;
    border-radius: 4px;
    padding-left: 10px;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.44px;
  }
  .dialog-body .time-range{
    margin-left: 22px;
    height:35px;
    line-height: 35px;
    margin-bottom: 35px;
  }
  .time-range p{
    float: left;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    letter-spacing:-0.44px;
    text-align:center;
    margin-right: 25px;
  }
  .time-range .block{
    float: left;
  }
  .time-range .date{
    float: left;
    width:22%;
    height:40px;
    line-height: 40px;
    color:#282828;
    font-size: 16px;
    margin-right: 13%;
    margin-left: 14px;
  }
  .el-date-editor.el-input{
    width:125px;
  }

  .dialog-footer{
    margin:-25px auto 15px;
    width:70%;
  }
  .dialog-footer button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:100px;
    width:40%;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }
  .dialog-footer .cancelButton{
    background: transparent;
    border:1px solid #009fdf;
    color: #282828;
    outline: none;
    margin-left: 7%;
  }

  .statics-table{
    width: 94%;
    margin:10px auto 0;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }

  .statics-table tr{
    height:25px;
  }

  .statics-table .rb{
    border-right:1px solid rgba(116,116,116,0.34);
  }


  .statics-table .bb{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }

  #est-a1c {
    width:94%;
    margin:15px auto;
    margin-top:30px;
    font-size:16px;
  }

  #est-a1c .left {
    float:left;
  }

  #est-a1c .right {
    float:right;
  }

  #est-a1c div {
    margin-bottom:5px;
  }

  #est-a1c .x_est-title {
    *font-size:14px;
    *font-weight:bold;
  }

  #est-a1c .est-ita {
    font-style:italic;
  }

  .chart-container .row1 div{
    float:left;
  }

  .chart-container .row1 .left-table{
    width:40%;
  }

  .chart-container .row1 .right-chart{
    width:60%;
    height:320px;
  }

  #chart1_6{
    width:100%;
    *height:300px;
    height:260px;
  }

  #chart1_7{
    width:100%;
    *height:300px;
    height:260px;
  }

  #chart1_5 {
    width:90%;
    *height:200px;
    height:96%;
  }

  .chart_title {
    float:left;
    width: 90%;
    text-align: center;
    font-size:16px;
    font-weight: bold;
  }

  .chart-container .row2{
    float:left;
  }

  .chart-container .row2.left-table{
    width:40%;
    margin-right:1%;
  }

  .chart-container .row2 .mtop{
    margin-top:30px;
  }

  .chart-container .row2.mid-table{
    width:32%;
    margin-right:1%;
  }

  .chart-container .row2.right-chart{
    width:58%;
    height:300px;
  }

  .hide {
    display: none;
  }

  #chart1_5_no_data {
    text-align: center;
    margin-top:70px;
  }

  #chart1_6_no_data {
    text-align: center;
    margin-top:70px;
  }
  #chart1_7_no_data {
    text-align: center;
    margin-top:70px;
  }

  /* big bold value */
  .bbv {
    font-size:24px;
    font-weight: bold;
    margin-right:5px;
    color:#282828;
  }

  /*some padding*/
  .sp {
    padding: 10px;
  }

</style>



// WEBPACK FOOTER //
// chart0.vue?2333dd59